import styled from 'styled-components'

import { FlyerCodesGiveOutWidgetUnstyled } from 'Containers/Form/City/Pickup/FlyerCodesGiveOutWidget/unstyled'

export const FlyerCodesGiveOutWidget = styled(FlyerCodesGiveOutWidgetUnstyled)`
  position: relative;
  border-radius: 4px;

  .CodeBlock:first-child {
    margin-left: 0;
  }

  .CodeBlock:last-child {
    margin-right: 0;
  }

  .CodeBlock {
    position: absolute;
    cursor: pointer;
    background-color: ${props => props.theme.colors.primary};
  }

  .CodeSelectDropDown {
    width: 256px;
    display: inline-block;
    vertical-align: top;
    margin-right: 2px;
    margin-top: 2px;
  }

  .CodeBlocksContainer {
    display: inline-block;
    vertical-align: top;
    position: relative;
    width: 100%;
  }

  .city-content .CodeBlocksContainer {
    padding-bottom: 20px;
  }

  .CodeBlocksContainer.DropZone:hover {
    background-color: blue;
  }

  .AvailableCodesContainer {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    /*user-select: none;*/
  }

  .GiveOutContainer {
    width: 50%;
    display: inline-block;
    vertical-align: top;
  }

  h3 {
    color: #7e8fa5;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 1.5px;
  }

  h3.flaggedBa {
    color: #ef405d;
    text-decoration: line-through;
  }

  .header {
    background-color: white;
    padding: 10px 10px 10px 0;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #7e8fa5;
    font-size: 11px;
    font-weight: bold;
    /*user-select: none;*/
  }

  .content {
    padding: 10px;
    max-height: 350px;
    overflow-x: auto;
    border: 1px solid #eceef0;
    min-height: 112px;
    /*user-select: none;*/
  }

  .city-content {
    margin-right: 20px;
  }

  .BADropZoneNotActive {
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #eceef0;
    margin-bottom: 10px;
  }

  .BADropZone {
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #eceef0;
    margin-bottom: 10px;
  }

  .AvailableCodesContainer > .city-content > .BADropZoneNotActive,
  .AvailableCodesContainer > .city-content > .BADropZone {
    padding: 0;
    border: 0px;
  }

  .BADropZoneNotActive > h3,
  .BADropZone > h3 {
    margin-top: 0;
  }

  .BADropZone:hover {
    background-color: #f7f4f4;
    border: 2px dashed #afa9a9;
  }

  .BADropZone:hover > .CodeBlocksContainer {
    opacity: 0.5;
  }

  .view-summary {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 20px;
    color: #9f9f9f;
    font-size: 12px;
  }

  .user-name {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 15px;
    margin-bottom: 10px;
  }

  .user-name > h3 {
    margin-top: 0;
    margin-bottom: 0px;
  }
`
